"use client";

import { useCallback, useRef } from "react";
import { useIsomorphicLayoutEffect } from "./useIsomorphicLayoutEffect";

const noop = () => {};

export function useStableCallback<T extends (...args: any[]) => any>(
  callback: T
): T;
export function useStableCallback<T extends (...args: any[]) => any>(
  callback?: T
): T | ((...args: Parameters<T>) => void);
export function useStableCallback<T extends (...args: any[]) => any>(
  callback: T
): T {
  const callbackRef = useRef(callback || noop);

  useIsomorphicLayoutEffect(() => {
    callbackRef.current = callback || noop;
  }, [callback]);

  return useCallback(
    (...args: Parameters<T>): ReturnType<T> => callbackRef.current(...args),
    [callbackRef]
  ) as T;
}
